// Maestros de Finanzas (sin API, en localStorage)

export interface FinanceClient {
  id: string;
  name: string;
  contactPerson: string;
  email: string;
  cif: string;
  phone: string;
  street: string;
  city: string;
  postalCode: string;
  province: string;
  country: string;
  account: string;
  paymentTerms: string;
  preferredPaymentMethod: string;
  billingLanguage: string;
  notes: string;
  attachments: string[];
  balance: number;
  status: 'Activo' | 'Inactivo';
}

export const PRESET_CLIENTS: FinanceClient[] = [
  {
    id: 'C-001',
    name: 'Librería Central Madrid S.L.',
    contactPerson: 'Carlos Gómez',
    email: 'cgomez@central.es',
    cif: 'B81234567',
    phone: '+34 91 521 1234',
    street: 'Calle Mayor 4',
    city: 'Madrid',
    postalCode: '28013',
    province: 'Madrid',
    country: 'España',
    account: '430000',
    paymentTerms: 'Neto 30 días',
    preferredPaymentMethod: 'Transferencia bancaria',
    billingLanguage: 'Español',
    notes: 'Cliente preferente con descuento editorial del 15%. Envíos a central de compras.',
    attachments: ['CIF_LibreriaCentral.pdf', 'ContratoDistribucion_2026.pdf'],
    balance: 1450.0,
    status: 'Activo'
  },
  {
    id: 'C-002',
    name: 'Marcial Pons Librería Barcelona',
    contactPerson: 'Mercedes Pons',
    email: 'm.pons@marcialpons.es',
    cif: 'B82345678',
    phone: '+34 93 301 5678',
    street: 'Carrer de Pau Claris 162',
    city: 'Barcelona',
    postalCode: '08037',
    province: 'Barcelona',
    country: 'España',
    account: '430000',
    paymentTerms: 'Neto 60 días',
    preferredPaymentMethod: 'Domiciliación SEPA',
    billingLanguage: 'Catalán',
    notes: 'Librería especializada jurídica y universitaria.',
    attachments: ['Mandato_SEPA_MarcialPons.pdf'],
    balance: 2180.5,
    status: 'Activo'
  },
  {
    id: 'C-003',
    name: 'Distribuciones Siglo XXI',
    contactPerson: 'Juan Ignacio',
    email: 'jignacio@sigloxxi.com',
    cif: 'B85544332',
    phone: '+34 91 600 7700',
    street: 'Av. de la Industria 45',
    city: 'Alcobendas',
    postalCode: '28108',
    province: 'Madrid',
    country: 'España',
    account: '431000',
    paymentTerms: 'Neto 90 días',
    preferredPaymentMethod: 'Pagaré comercial',
    billingLanguage: 'Español',
    notes: 'Distribuidor nacional con remesas periódicas.',
    attachments: ['AvalBancario_2026.pdf'],
    balance: 0,
    status: 'Activo'
  },
  {
    id: 'C-004',
    name: 'Universidad Complutense de Madrid',
    contactPerson: 'Dr. Alejandro Ruiz',
    email: 'compras.pdi@ucm.es',
    cif: 'Q2818001F',
    phone: '+34 91 394 1000',
    street: 'Av. Séneca 2, Ciudad Universitaria',
    city: 'Madrid',
    postalCode: '28040',
    province: 'Madrid',
    country: 'España',
    account: '430000',
    paymentTerms: 'Neto 60 días',
    preferredPaymentMethod: 'Transferencia bancaria',
    billingLanguage: 'Español',
    notes: 'Sector público. Requiere factura electrónica FACE y código DIR3.',
    attachments: ['DIR3_UCM.pdf'],
    balance: 3500.0,
    status: 'Activo'
  },
  {
    id: 'C-005',
    name: 'La Casa del Libro',
    contactPerson: 'Laura Méndez',
    email: 'lmendez@casadellibro.es',
    cif: 'A82003344',
    phone: '+34 902 151 525',
    street: 'Gran Vía 29',
    city: 'Madrid',
    postalCode: '28013',
    province: 'Madrid',
    country: 'España',
    account: '430000',
    paymentTerms: 'Neto 30 días',
    preferredPaymentMethod: 'Transferencia bancaria',
    billingLanguage: 'Español',
    notes: 'Cadena de librerías. Albaranes con trazabilidad EDI.',
    attachments: [],
    balance: 840.2,
    status: 'Activo'
  }
];

export interface FinanceProduct {
  id: string;
  type: 'Bien' | 'Servicio';
  name: string;
  sku: string;
  description: string;
  price: number;
  incomeAccount: string;
  vatRate: number;
  isPurchasedFromSupplier: boolean;
  expenseAccount: string;
}

export const PRESET_PRODUCTS: FinanceProduct[] = [
  {
    id: 'P-001',
    type: 'Bien',
    name: 'Manual de Derecho Constitucional (Vol. 1)',
    sku: '978-84-1355-120-1',
    description: 'Manual académico de referencia para el grado de Derecho. Tapa blanda, 640 páginas.',
    price: 35.0,
    incomeAccount: '700000',
    vatRate: 4,
    isPurchasedFromSupplier: true,
    expenseAccount: '600000'
  },
  {
    id: 'P-002',
    type: 'Bien',
    name: 'Tratado de Derecho Civil Español',
    sku: '978-84-1355-230-7',
    description: 'Obra completa comentada de jurisprudencia civil. Encuadernación en tela, tomo de lujo.',
    price: 85.0,
    incomeAccount: '700000',
    vatRate: 4,
    isPurchasedFromSupplier: true,
    expenseAccount: '600000'
  },
  {
    id: 'P-003',
    type: 'Servicio',
    name: 'Suscripción Anual Revista de Jurisprudencia',
    sku: 'S-RV-JURIS',
    description: 'Acceso digital anual a 12 números de la revista y archivo histórico.',
    price: 120.0,
    incomeAccount: '705000',
    vatRate: 10,
    isPurchasedFromSupplier: false,
    expenseAccount: ''
  },
  {
    id: 'P-004',
    type: 'Servicio',
    name: 'Acceso Licencia Premium BaaS Platform',
    sku: 'LIC-BAAS-PREM',
    description: 'Licencia multiusuario para plataforma tecnológica Book as a Service.',
    price: 250.0,
    incomeAccount: '705000',
    vatRate: 21,
    isPurchasedFromSupplier: false,
    expenseAccount: ''
  },
  {
    id: 'P-005',
    type: 'Servicio',
    name: 'Gastos de Envío & Logística Editorial',
    sku: 'LOG-SHIPPING',
    description: 'Transporte y entrega certificada de pedidos editoriales peninsulares.',
    price: 9.9,
    incomeAccount: '705000',
    vatRate: 21,
    isPurchasedFromSupplier: true,
    expenseAccount: '624000'
  }
];

export interface FinanceSupplier {
  id: string;
  name: string;
  cif: string;
  type: 'Proveedor' | 'Acreedor';
  contactPerson: string;
  email: string;
  phone: string;
  street: string;
  city: string;
  postalCode: string;
  province: string;
  country: string;
  paymentTerms: string;
  preferredPaymentMethod: string;
  account: string;
  creditLimit: number;
  notes: string;
  attachments: string[];
  pendingBalance: number;
  status: 'Activo' | 'Inactivo';
}

export const PRESET_SUPPLIERS: FinanceSupplier[] = [
  {
    id: 'PRV-001',
    name: 'Papelera de Alcalá S.A.',
    cif: 'A28114422',
    type: 'Proveedor',
    contactPerson: 'Fernando Gómez',
    email: 'comercial@papeleraalcala.es',
    phone: '+34 91 888 4400',
    street: 'Polígono Industrial Las Eras 12',
    city: 'Alcalá de Henares',
    postalCode: '28805',
    province: 'Madrid',
    country: 'España',
    paymentTerms: 'Neto 60 días',
    preferredPaymentMethod: 'Transferencia bancaria',
    account: '400000',
    creditLimit: 25000.0,
    notes: 'Proveedor principal de papel offset y cartulina de portadas. Pedidos mínimos de 2 toneladas.',
    attachments: ['FichaTecnica_PapelOffset.pdf', 'CertificadoPEFC_2026.pdf'],
    pendingBalance: 605.0,
    status: 'Activo'
  },
  {
    id: 'PRV-002',
    name: 'Gráficas del Sur S.L.',
    cif: 'B41223344',
    type: 'Proveedor',
    contactPerson: 'Carmen Navarro',
    email: 'produccion@graficasdelsur.com',
    phone: '+34 95 499 1200',
    street: 'Av. Kansas City 88',
    city: 'Sevilla',
    postalCode: '41007',
    province: 'Sevilla',
    country: 'España',
    paymentTerms: 'Neto 30 días',
    preferredPaymentMethod: 'Transferencia bancaria',
    account: '400000',
    creditLimit: 40000.0,
    notes: 'Impresión offset y digital de tiradas medias y grandes con encuadernación rústica cosida.',
    attachments: ['TarifaImpresion2026.pdf'],
    pendingBalance: 2238.5,
    status: 'Activo'
  },
  {
    id: 'PRV-003',
    name: 'Electra Suministros S.A.',
    cif: 'A28001122',
    type: 'Acreedor',
    contactPerson: 'Atención al Cliente Empresas',
    email: 'empresas@electra.es',
    phone: '+34 900 100 200',
    street: 'Paseo de la Castellana 140',
    city: 'Madrid',
    postalCode: '28046',
    province: 'Madrid',
    country: 'España',
    paymentTerms: 'Inmediato (Contado)',
    preferredPaymentMethod: 'Domiciliación SEPA',
    account: '410000',
    creditLimit: 5000.0,
    notes: 'Suministro de energía eléctrica de la sede editorial y almacén.',
    attachments: ['ContratoSuministro_Electra.pdf'],
    pendingBalance: 217.8,
    status: 'Activo'
  }
];

export interface ReceivedInvoice {
  id: string;
  date: string;
  supplier: string;
  cif: string;
  concept: string;
  base: number;
  vat: number;
  total: number;
  status: 'Pagada' | 'Pendiente';
  account: string;
}

export const PRESET_RECEIVED_INVOICES: ReceivedInvoice[] = [
  { id: 'FR-2026-003', date: '2026-01-18', supplier: 'ELECTRA S.A.', cif: 'A28001122', concept: 'Suministros Oficina Central', base: 180.0, vat: 37.8, total: 217.8, status: 'Pagada', account: '628000' },
  { id: 'FR-2026-015', date: '2026-02-10', supplier: 'PAPELERA DE ALCALÁ S.A.', cif: 'A28114422', concept: 'Bobinas de papel editorial', base: 500.0, vat: 105.0, total: 605.0, status: 'Pagada', account: '600000' },
  { id: 'FR-2026-021', date: '2026-02-25', supplier: 'GRÁFICAS DEL SUR S.L.', cif: 'B41223344', concept: 'Impresión y encuadernación tirada', base: 1850.0, vat: 388.5, total: 2238.5, status: 'Pendiente', account: '607000' },
  { id: 'FR-2026-024', date: '2026-03-02', supplier: 'HOSTING & CLOUD SERVICES', cif: 'B84445566', concept: 'Servidores BaaS y bases de datos', base: 450.0, vat: 94.5, total: 544.5, status: 'Pendiente', account: '629000' }
];

export interface TaxType {
  id: string;
  name: string;
  taxCategory: 'IVA' | 'IRPF';
  rate: number;
  repercutidoAccount: string;
  soportadoAccount: string;
  account: string;
  description: string;
  isActive: boolean;
}

export const PRESET_TAX_TYPES: TaxType[] = [
  { id: 'IVA-0', name: 'IVA 0% Exento', taxCategory: 'IVA', rate: 0, repercutidoAccount: '477000', soportadoAccount: '472000', account: '', description: 'Operaciones exentas de IVA según art. 20 LIVA o exportaciones.', isActive: true },
  { id: 'IVA-4', name: 'IVA 4% Superreducido', taxCategory: 'IVA', rate: 4, repercutidoAccount: '477000', soportadoAccount: '472000', account: '', description: 'Libros, periódicos y revistas que no contengan única o fundamentalmente publicidad.', isActive: true },
  { id: 'IVA-10', name: 'IVA 10% Reducido editorial', taxCategory: 'IVA', rate: 10, repercutidoAccount: '477000', soportadoAccount: '472000', account: '', description: 'Contenidos culturales, suscripciones mixtas y suministros editoriales específicos.', isActive: true },
  { id: 'IVA-21', name: 'IVA 21% General', taxCategory: 'IVA', rate: 21, repercutidoAccount: '477000', soportadoAccount: '472000', account: '', description: 'Tipo estándar aplicable a licencias de software, servicios BaaS y envíos.', isActive: true },
  { id: 'IRPF-0', name: 'IRPF 0% Sin retención', taxCategory: 'IRPF', rate: 0, repercutidoAccount: '', soportadoAccount: '', account: '475100', description: 'Proveedores societarios o exentos de retención a cuenta.', isActive: true },
  { id: 'IRPF-15', name: 'IRPF 15% Profesionales', taxCategory: 'IRPF', rate: 15, repercutidoAccount: '', soportadoAccount: '', account: '475100', description: 'Retención general para profesionales independientes (correctores, traductores, autores).', isActive: true },
  { id: 'IRPF-19', name: 'IRPF 19% Alquileres', taxCategory: 'IRPF', rate: 19, repercutidoAccount: '', soportadoAccount: '', account: '475100', description: 'Retención por arrendamiento de inmuebles urbanos afectos a la actividad.', isActive: true }
];

export interface FiscalDeadline {
  id: string;
  date: string;
  model: string;
  description: string;
  status: 'Próximo plazo' | 'Borrador listo' | 'Anual';
  note: string;
}

export const FISCAL_DEADLINES: FiscalDeadline[] = [
  { id: 'VTO-111-1T', date: '2026-04-20', model: 'Modelo 111 (1T Retenciones)', description: 'Retenciones sobre nóminas y facturas profesionales correspondientes al primer trimestre.', status: 'Próximo plazo', note: 'Faltan 21 días para el cierre' },
  { id: 'VTO-303-1T', date: '2026-04-20', model: 'Modelo 303 (1T IVA)', description: 'Autoliquidación periódica del Impuesto sobre el Valor Añadido del primer trimestre.', status: 'Borrador listo', note: 'Cuadre verificado con Libro Diario' },
  { id: 'VTO-200', date: '2026-07-25', model: 'Modelo 200 (Impuesto Sociedades)', description: 'Declaración anual del Impuesto sobre Sociedades ejercicio fiscal 2025.', status: 'Anual', note: 'Pendiente de auditoría contable' }
];

export interface PaymentCondition {
  /** Código visible (COND-30); es el identificador que usa la interfaz */
  id: string;
  /** id numérico de payment_conditions en el backend */
  dbId?: string;
  name: string;
  days: number;
  description: string;
  isActive: boolean;
}

export interface PaymentMethod {
  /** Código visible (MET-TRF); es el valor que usan los selects de los formularios */
  id: string;
  /** id numérico de payment_methods en el backend */
  dbId?: string;
  name: string;
  type: string;
  account: string;
  requiresIban: boolean;
  description: string;
  isActive: boolean;
}

// Claves de localStorage
export type QuoteStatus = 'Pendiente' | 'Aceptado' | 'Rechazado';

export const QUOTE_STATUSES: QuoteStatus[] = ['Pendiente', 'Aceptado', 'Rechazado'];

export interface QuoteLine {
  id: string;
  productId: string;
  description: string;
  quantity: number;
  price: number;
  vat: number;
}

export interface Quote {
  number: string;
  clientId: string;
  clientName: string;
  clientCif: string;
  date: string;
  validUntil: string;
  lines: QuoteLine[];
  subtotal: number;
  vat: number;
  total: number;
  status: QuoteStatus;
  notes: string;
  sentAt: string;
}

// Sin cliente enlazado: al editarlos hay que elegir el cliente real
export const PRESET_QUOTES: Quote[] = [
  {
    number: 'PRE-2026-001',
    clientId: '',
    clientName: 'Universidad Complutense de Madrid',
    clientCif: 'Q2818001F',
    date: '2026-02-10',
    validUntil: '2026-03-31',
    lines: [{ id: '1', productId: '', description: 'Lote de 120 manuales de Derecho Constitucional para departamento', quantity: 120, price: 35, vat: 4 }],
    subtotal: 4200,
    vat: 168,
    total: 4368,
    status: 'Aceptado',
    notes: '',
    sentAt: '2026-02-10'
  },
  {
    number: 'PRE-2026-002',
    clientId: '',
    clientName: 'Marcial Pons Librería Barcelona',
    clientCif: 'B82345678',
    date: '2026-02-28',
    validUntil: '2026-04-15',
    lines: [{ id: '1', productId: '', description: 'Tirada especial comentada de Tratado de Derecho Civil con descuento comercial', quantity: 1, price: 1850, vat: 4 }],
    subtotal: 1850,
    vat: 74,
    total: 1924,
    status: 'Pendiente',
    notes: '',
    sentAt: '2026-02-28'
  },
  {
    number: 'PRE-2026-003',
    clientId: '',
    clientName: 'Distribuciones Siglo XXI',
    clientCif: 'B85544332',
    date: '2026-03-05',
    validUntil: '2026-04-30',
    lines: [{ id: '1', productId: '', description: 'Preventa y distribución de 300 suscripciones anuales a Revista de Jurisprudencia', quantity: 300, price: 120, vat: 10 }],
    subtotal: 36000,
    vat: 3600,
    total: 39600,
    status: 'Pendiente',
    notes: '',
    sentAt: ''
  }
];

export type SalesReceiptStatus = 'Borrador' | 'Emitido';

export interface SalesReceipt {
  number: string;
  clientId: string;
  clientName: string;
  clientCif: string;
  date: string;
  lines: QuoteLine[];
  paymentMethod: string;
  targetAccount: string;
  subtotal: number;
  vat: number;
  total: number;
  status: SalesReceiptStatus;
}

// Importes con el 4% de IVA incluido; sin cliente enlazado, como los presupuestos de ejemplo
export const PRESET_SALES_RECEIPTS: SalesReceipt[] = [
  {
    number: 'RV-2026-001',
    clientId: '',
    clientName: 'Venta mostrador librería',
    clientCif: '',
    date: '2026-02-15',
    lines: [{ id: '1', productId: '', description: 'Venta directa al contado 2 ejemplares Manual Derecho', quantity: 1, price: 67.31, vat: 4 }],
    paymentMethod: 'Efectivo (Caja)',
    targetAccount: '570000',
    subtotal: 67.31,
    vat: 2.69,
    total: 70,
    status: 'Emitido'
  },
  {
    number: 'RV-2026-002',
    clientId: '',
    clientName: 'Cliente particular presencial',
    clientCif: '',
    date: '2026-02-20',
    lines: [{ id: '1', productId: '', description: 'Venta 1 tomo Tratado de Derecho Civil', quantity: 1, price: 81.73, vat: 4 }],
    paymentMethod: 'Tarjeta de crédito / débito',
    targetAccount: '572000',
    subtotal: 81.73,
    vat: 3.27,
    total: 85,
    status: 'Emitido'
  },
  {
    number: 'RV-2026-003',
    clientId: '',
    clientName: 'Feria del Libro Madrid',
    clientCif: '',
    date: '2026-03-01',
    lines: [{ id: '1', productId: '', description: 'Lote de publicaciones fondo editorial en metálico', quantity: 1, price: 236.06, vat: 4 }],
    paymentMethod: 'Efectivo (Caja)',
    targetAccount: '570000',
    subtotal: 236.06,
    vat: 9.44,
    total: 245.5,
    status: 'Emitido'
  }
];

export interface CreditNote {
  number: string;
  clientId: string;
  clientName: string;
  clientCif: string;
  date: string;
  invoiceId: string;
  invoiceNumber: string;
  lines: QuoteLine[];
  reason: string;
  subtotal: number;
  vat: number;
  total: number;
}

// Importes con el 4% de IVA incluido; sin cliente ni factura enlazados
export const PRESET_CREDIT_NOTES: CreditNote[] = [
  {
    number: 'NC-2026-001',
    clientId: '',
    clientName: 'EDITORIAL SOL S.L.',
    clientCif: '',
    date: '2026-02-02',
    invoiceId: '',
    invoiceNumber: 'F-2026-102',
    lines: [{ id: '1', productId: '', description: 'Abono 3 ejemplares con tara de encuadernación', quantity: 1, price: 100.96, vat: 4 }],
    reason: 'Abono por 3 ejemplares con tara de encuadernación',
    subtotal: 100.96,
    vat: 4.04,
    total: 105
  },
  {
    number: 'NC-2026-002',
    clientId: '',
    clientName: 'Librería Central Madrid S.L.',
    clientCif: '',
    date: '2026-02-18',
    invoiceId: '',
    invoiceNumber: 'F-2026-105',
    lines: [{ id: '1', productId: '', description: 'Rappel por volumen de compras de febrero', quantity: 1, price: 209.62, vat: 4 }],
    reason: 'Rappel acordado por volumen de compras de febrero',
    subtotal: 209.62,
    vat: 8.38,
    total: 218
  }
];

export const STORAGE_KEYS = {
  clients: 'albatross_clientes_maestro',
  products: 'albatross_articulos_maestro',
  suppliers: 'albatross_proveedores_maestro',
  receivedInvoices: 'albatross_facturas_recibidas',
  taxTypes: 'albatross_tipos_impuestos',
  quotes: 'albatross_presupuestos',
  salesReceipts: 'albatross_recibos_venta',
  creditNotes: 'albatross_notas_credito'
};

export interface MasterAddress {
  street: string;
  city: string;
  postalCode: string;
  province: string;
  country: string;
}

export const fullAddress = (a: MasterAddress) =>
  [a.street, [a.postalCode, a.city].filter(Boolean).join(' '), a.province !== a.city ? a.province : '']
    .filter(Boolean)
    .join(', ');

export const formatEuro = (val: number, privacyMode: boolean) => {
  if (privacyMode) return '•••••€';
  return `${val.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
};

export const nextCode = (prefix: string, ids: string[]) => {
  const max = ids.reduce((acc, id) => {
    const n = parseInt(id.replace(/\D/g, ''), 10);
    return isNaN(n) ? acc : Math.max(acc, n);
  }, 0);
  return `${prefix}-${String(max + 1).padStart(3, '0')}`;
};
